import React from 'react'
import { Link } from 'react-router-dom'
import { Settings } from 'lucide-react'

const SystemSettingsPage: React.FC = () => {
  return (
    <div className="h-full flex-1">
      <div className="flex-1 space-y-6 p-8 pt-6">
        {/* Hero Section */}
        <div className="rounded-2xl overflow-hidden shadow-lg">
        <div
          className="flex"
          style={{
            background: 'linear-gradient(to right, #475569, #64748b)',
          }}
        >
          <div className="p-8 flex justify-between items-start relative w-full">
            <div className="space-y-3 flex-1">
              <div className="text-white/80 text-sm font-medium">
                Sistem Ayarlar Paneli
              </div>
              <h1 className="text-3xl font-bold text-white">
                Genel Sistem Konfigürasyonu
              </h1>
              <p className="text-white/90 text-sm max-w-xl leading-relaxed">
                Sistemin genel ayarlarını yönetin. Güvenlik, e-posta, yedekleme ve
                duyuru engelleme kurallarını yapılandırın. Zaman dilimi, dil ve diğer
                sistem parametrelerini düzenleyin.
              </p>
            </div>
            <div
              className="w-40 h-40 rounded-lg overflow-hidden relative z-10 flex items-center justify-center ml-8"
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              }}
            >
              <Settings className="w-20 h-20 text-white" strokeWidth={1.5} />
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Genel Ayarlar */}
        <div className="bg-card rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Genel Ayarlar</h2>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">
                Sistem Adı
              </label>
              <input
                type="text"
                className="w-full p-2 border border-input rounded-md"
                placeholder="Cloud Jukebox Manager"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                Zaman Dilimi
              </label>
              <select className="w-full p-2 border border-input rounded-md">
                <option>UTC+03:00 - İstanbul</option>
                <option>UTC+00:00 - London</option>
                <option>UTC-05:00 - New York</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                Dil
              </label>
              <select className="w-full p-2 border border-input rounded-md">
                <option>Türkçe</option>
                <option>English</option>
              </select>
            </div>
          </div>
        </div>

        {/* Güvenlik Ayarları */}
        <div className="bg-card rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Güvenlik Ayarları</h2>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">
                Minimum Şifre Uzunluğu
              </label>
              <input
                type="number"
                className="w-full p-2 border border-input rounded-md"
                placeholder="8"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                Oturum Zaman Aşımı (dakika)
              </label>
              <input
                type="number"
                className="w-full p-2 border border-input rounded-md"
                placeholder="30"
              />
            </div>

            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="2fa"
                className="rounded border-input"
              />
              <label htmlFor="2fa" className="text-sm font-medium">
                İki Faktörlü Kimlik Doğrulamayı Zorunlu Kıl
              </label>
            </div>
          </div>
        </div>

        {/* E-posta Ayarları */}
        <div className="bg-card rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-4">E-posta Ayarları</h2>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">
                SMTP Sunucu
              </label>
              <input
                type="text"
                className="w-full p-2 border border-input rounded-md"
                placeholder="smtp.example.com"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                SMTP Port
              </label>
              <input
                type="number"
                className="w-full p-2 border border-input rounded-md"
                placeholder="587"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                E-posta Adresi
              </label>
              <input
                type="email"
                className="w-full p-2 border border-input rounded-md"
                placeholder="noreply@example.com"
              />
            </div>
          </div>
        </div>

        {/* Yedekleme Ayarları */}
        <div className="bg-card rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Yedekleme Ayarları</h2>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">
                Otomatik Yedekleme
              </label>
              <select className="w-full p-2 border border-input rounded-md">
                <option>Günlük</option>
                <option>Haftalık</option>
                <option>Aylık</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                Yedekleme Saklama Süresi (gün)
              </label>
              <input
                type="number"
                className="w-full p-2 border border-input rounded-md"
                placeholder="30"
              />
            </div>
          </div>
        </div>
        
     
      </div>

      {/* Mesai Saatleri ve Duyuru Yönetimi */}
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Mesai Saatleri */}
        <div className="bg-card rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Mesai Saatleri</h2>

          <div className="space-y-4">
            <p className="text-sm text-gray-600">
              Anons oluşturma mesai saatlerini yönetin. Hangi günlerde ve saatlerde anons
              oluşturulabileceğini belirleyin.
            </p>

            <div>
              <Link
                to="/system-settings/business-hours"
                className="inline-flex items-center px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
              >
                Mesai Saatlerini Yönet
              </Link>
            </div>
          </div>
        </div>

        {/* Duyuru Engelleme Kuralları */}
        <div className="bg-card rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Duyuru Engelleme Kuralları</h2>

          <div className="space-y-4">
            <p className="text-sm text-gray-600">
              Duyuru engellemeleri, belirli zaman aralıklarında (tatil günleri, özel günler vb.) yöneticilerin
              duyuru oluşturmasını engellemek için kullanılır.
            </p>

            <div>
              <Link
                to="/system-settings/announcement-rules"
                className="inline-flex items-center px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
              >
                Engelleme Kurallarını Yönet
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Kaydet Butonu */}
      <div className="flex justify-end">
        <button className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90">
          Ayarları Kaydet
        </button>
      </div>
      </div>
    </div>
  )
}

export default SystemSettingsPage
